import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import signupReducer from '../features/auth/signupSlice'
import jobReducer from '../features/auth/jobSlice';
import jobFetchDeleteReducer from '../features/auth/jobsFetchDelete'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    signup: signupReducer,
    jobs: jobReducer,
    jobFetchDelete: jobFetchDeleteReducer
  },
});
